import { render, staticRenderFns } from "./BtnSearch.vue?vue&type=template&id=ef497136"
import script from "./BtnSearch.vue?vue&type=script&lang=js"
export * from "./BtnSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports